'use client';
import { jsx, jsxs } from "react/jsx-runtime";
import { Icon } from "@tameeni/icons";
import { cn } from "@tameeni/shared-logic";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../accordion/accordion.js";
import { InfoTooltip } from "../info-tooltip/info-tooltip.js";
function CollapsibleTable({
  children,
  defaultOpen,
  className,
  type = "single",
  collapsible = true
}) {
  return /* @__PURE__ */ jsx("div", { className: cn(className), children: /* @__PURE__ */ jsx(Accordion, { type, collapsible, children }) });
}
function Table({ children, value, className }) {
  return /* @__PURE__ */ jsx(AccordionItem, { value, className: cn("border-0", className), children });
}
function Title({ children, className }) {
  return /* @__PURE__ */ jsx(
    AccordionTrigger,
    {
      removeIcon: true,
      className: "w-full p-4 group bg-slate-100 data-[state=open]:bg-blue-100",
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          className: cn(
            "flex items-center justify-between text-s2 w-full",
            className
          ),
          children: [
            /* @__PURE__ */ jsx("div", { className: "flex items-center", children }),
            /* @__PURE__ */ jsx(
              Icon,
              {
                name: "ChevronDown",
                className: "size-4 text-blue group-data-[state=open]:rotate-180 transition-transform"
              }
            )
          ]
        }
      )
    }
  );
}
function Content({ children, className }) {
  return /* @__PURE__ */ jsx(AccordionContent, { className, children });
}
function Row({ label, tooltip, children, className }) {
  return /* @__PURE__ */ jsxs("div", { className: cn("flex flex-col ", className), children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center bg-slate-100 px-4 py-3 gap-1", children: [
      /* @__PURE__ */ jsx("div", { className: "text-s3 text-slate-600", children: label }),
      tooltip && /* @__PURE__ */ jsx("div", { className: "flex items-center", children: /* @__PURE__ */ jsx(InfoTooltip, { children: tooltip }) })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "flex w-full space-x-4 py-3", children })
  ] });
}
function Column({ children, className }) {
  return /* @__PURE__ */ jsx("div", { className: cn("flex-1 text-center text-s3", className), children });
}
CollapsibleTable.Table = Table;
CollapsibleTable.Title = Title;
CollapsibleTable.Content = Content;
CollapsibleTable.Row = Row;
CollapsibleTable.Column = Column;
export {
  CollapsibleTable,
  CollapsibleTable as default
};
